// Related products — fetches Shopify product recommendations for the current
// product and swaps them into the placeholder. One deferred module. Zero
// dependencies. Silent no-op on any failure (the section just stays empty/hidden).
(() => {
  const mount = document.querySelector('[data-related-products]');
  if (!mount || !mount.dataset.url) return;

  fetch(mount.dataset.url)
    .then((res) => (res.ok ? res.text() : Promise.reject()))
    .then((html) => {
      const next = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector('[data-related-products]');
      if (next) mount.innerHTML = next.innerHTML;
    })
    .catch(() => {});
})();
